import { render, staticRenderFns } from "./fasilitator.vue?vue&type=template&id=00aa64c8"
import script from "./fasilitator.vue?vue&type=script&lang=js"
export * from "./fasilitator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports